// Mock data for Brain Waves Ventures website

export const mockData = {
  // Founder information
  founder: {
    name: "Rossana Auditore",
    title: "Founder & Lead Therapist",
    bio: "With over 15 years of experience in therapy and coaching, Rossana has dedicated her life to empowering women and professionals worldwide. Her unique approach combines traditional therapeutic methods with innovative coaching techniques, creating transformative experiences that heal, inspire, and connect.",
    image: "/rosanna.jpeg",
    credentials: ["Licensed Clinical Therapist", "Certified Life Coach", "International Retreat Leader", "Women's Empowerment Specialist"]
  },

  // Services data
  services: [
    {
      id: 1,
      title: "Individual Therapy",
      description: "Personalized one-on-one sessions tailored to your unique healing journey and personal growth goals.",
      duration: "50 minutes",
      price: "$150",
      features: [
        "Personalized treatment approach",
        "Trauma-informed care",
        "Goal-oriented sessions",
        "Flexible scheduling",
        "Secure, confidential environment"
      ],
      image: "https://images.pexels.com/photos/4098370/pexels-photo-4098370.jpeg"
    },
    {
      id: 2,
      title: "Group Coaching",
      description: "Connect with like-minded individuals in supportive group environments designed for collective growth and empowerment.",
      duration: "90 minutes",
      price: "$75",
      features: [
        "Small group sessions (6-8 participants)",
        "Peer support network",
        "Shared learning experiences",
        "Community building",
        "Regular progress check-ins"
      ],
      image: "https://images.unsplash.com/photo-1636986905406-758b0e280f49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50fGVufDB8fHx8MTc1OTUxMDUxMXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      title: "International Retreats",
      description: "Transform through immersive experiences in beautiful global destinations, combining therapy, coaching, and cultural exploration.",
      duration: "5-7 days",
      price: "$2,500",
      features: [
        "Luxury accommodations",
        "Daily therapy sessions",
        "Cultural immersion activities",
        "Wellness workshops",
        "Lifelong connections",
        "All meals included"
      ],
      image: "https://images.unsplash.com/photo-1500904156668-758cff89dcff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoZWFsaW5nfGVufDB8fHx8MTc1OTUxMDUwNnww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      title: "Online Workshops",
      description: "Access our expertise from anywhere in the world through interactive online workshops and webinars.",
      duration: "60 minutes",
      price: "$35",
      features: [
        "Live interactive sessions",
        "Recorded for later access",
        "Downloadable resources",
        "Q&A with experts",
        "Community forum access"
      ],
      image: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxoZWFsaW5nfGVufDB8fHx8MTc1OTUxMDUwNnww&ixlib=rb-4.1.0&q=85"
    }
  ],

  // Resources data
  resources: [
    {
      id: 1,
      title: "Building Resilience in Uncertain Times",
      type: "Article",
      category: "Mental Health",
      excerpt: "Learn practical strategies to build emotional resilience and navigate life's challenges with confidence and grace.",
      readTime: "8 min read",
      date: "2025-01-15",
      image: "https://images.unsplash.com/photo-1483691278019-cb7253bee49f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoZWFsaW5nfGVufDB8fHx8MTc1OTUxMDUwNnww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      title: "Self-Care Checklist for Busy Professionals",
      type: "Download",
      category: "Wellness",
      excerpt: "A comprehensive checklist to help you prioritize self-care in your busy schedule.",
      readTime: "PDF Download",
      date: "2025-01-10",
      image: "https://images.pexels.com/photos/40192/woman-happiness-sunrise-silhouette-40192.jpeg"
    },
    {
      id: 3,
      title: "Meditation for Beginners: A 10-Minute Guide",
      type: "Video",
      category: "Mindfulness",
      excerpt: "Start your meditation journey with this gentle, guided session perfect for beginners.",
      readTime: "10 min video",
      date: "2025-01-05",
      image: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxoZWFsaW5nfGVufDB8fHx8MTc1OTUxMDUwNnww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      title: "The Power of Community in Healing",
      type: "Article",
      category: "Community",
      excerpt: "Discover how connecting with others can accelerate your healing journey and personal growth.",
      readTime: "6 min read",
      date: "2024-12-28",
      image: "https://images.unsplash.com/photo-1636986905406-758b0e280f49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGVtcG93ZXJtZW50fGVufDB8fHx8MTc1OTUxMDUxMXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 5,
      title: "Gratitude Journal Template",
      type: "Download",
      category: "Wellness",
      excerpt: "Transform your mindset with our beautiful, printable gratitude journal template.",
      readTime: "PDF Download",
      date: "2024-12-20",
      image: "https://images.unsplash.com/photo-1541976844346-f18aeac57b06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHx0aGVyYXB5fGVufDB8fHx8MTc1OTUxMDUwMHww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 6,
      title: "Breaking Through Limiting Beliefs",
      type: "Article",
      category: "Personal Growth",
      excerpt: "Identify and overcome the limiting beliefs that are holding you back from your full potential.",
      readTime: "12 min read",
      date: "2024-12-15",
      image: "https://images.unsplash.com/photo-1500904156668-758cff89dcff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxoZWFsaW5nfGVufDB8fHx8MTc1OTUxMDUwNnww&ixlib=rb-4.1.0&q=85"
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Sarah Mitchell",
      role: "Marketing Executive",
      text: "Brain Waves Ventures transformed my life. The supportive community and expert guidance helped me find my inner strength and overcome years of self-doubt. I'm forever grateful for this journey.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1494790108755-2616c669e413?w=150"
    },
    {
      id: 2,
      name: "Jessica Chen",
      role: "Entrepreneur",
      text: "The international retreat in Bali was life-changing. I connected with amazing women from around the world and discovered my true potential. The experience exceeded all my expectations.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
    },
    {
      id: 3,
      name: "Maria Rodriguez",
      role: "Healthcare Professional",
      text: "Rossana's approach to therapy and coaching is unlike anything I've experienced. I feel empowered and supported every step of the way. The group sessions created lasting friendships.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
    },
    {
      id: 4,
      name: "Emily Watson",
      role: "Teacher",
      text: "The online workshops fit perfectly into my busy schedule. The content is rich, practical, and immediately applicable to my daily life. I've grown so much in just a few months.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=150"
    }
  ],

  // Team members
  team: [
    {
      id: 1,
      name: "Rossana Auditore",
      role: "Founder & Lead Therapist",
      bio: "Rossana Auditore is a multidisciplinary professional whose career bridges medicine, international business, and psychology.",
      image: "/rosanna.jpeg"
    },
    {
      id: 2,
      name: "Alejandra Benítez",
      role: "Clinical Psychologist",
      bio: "Clinical Psychologist with more than 30 years of experience in Cognitive Behavioral Therapy, specializing in anxiety, depression, trauma, and major life transitions.",
      image: "/alejandra.jpeg"
    },
    {
      id: 3,
      name: "Alicia Díaz Nilo",
      role: "Social Worker & Victim Protection Specialist",
      bio: "Social worker and recognized authority in victim protection, gender equity, inclusive labor practices, and social dialogue with extensive experience in government and international organizations.",
      image: "/alicia.jpeg"
    },
    {
      id: 4,
      name: "Carmen Gloria Rodriguez",
      role: "Public Health Manager",
      bio: "Seasoned Public Health Manager with over 30 years of experience in community health, disease education, and prevention, specializing in sexually transmitted and contagious diseases.",
      image: "/carmen.jpeg"
    }
  ],

  // Contact form submission handler
  submitContactForm: (formData) => {
    // Mock API call - in real implementation this would go to backend
    console.log('Contact form submitted:', formData);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: 'Thank you for your message! We will get back to you within 24 hours.'
        });
      }, 1000);
    });
  },

  // Newsletter subscription
  subscribeNewsletter: (email) => {
    console.log('Newsletter subscription:', email);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: 'Successfully subscribed to our newsletter!'
        });
      }, 500);
    });
  }
};

export default mockData;